<template>
  <div class="collectDetail">
    <div class="title">
      <div class="name">
        {{ postSendList[index].WorkName }}
      </div>
      <div class="returnList" @click="returnList">
        返回列表
      </div>
    </div>
    <div class="content">
      <div class="imgUrl">
        <el-image fit="cover" :src="postSendList[index].CoverPic" />
      </div>
      <div class="imgDetail">
        <div>
          <span class="paipin">拍品类别：</span>{{ postSendList[index].SortName || '--' }}
        </div>
        <div>
          <span class="paipin">拍品标签：</span>{{ postSendList[index].WorkMark || '--' }}
        </div>
        <div>
          <span class="paipin">拍品尺寸：</span>{{ postSendList[index].Size || '--' }}
        </div>
        <div>
          <span class="paipin">拍品报价：</span>{{ postSendList[index].SoldPrice || '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postDetail, postCollect, postSend } from "@/api/company";

export default {
  name: "collectDetail",
  data() {
    return {
      id: this.$route.query.id,
      index: this.$route.query.index,
      postSendList: []
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.postSend(res.data.organ_id);
      });
    },
    postSend(id) {
      postSend({
        organCode: id,
      }).then((res) => {
        console.log(res);
        this.postSendList = res.data.list;
      });
    },
    returnList() {
      this.$router.push(`/${this.$router.history.current.params.name}/collect?id=2`)
    }
  },
};
</script>

<style lang="scss" scoped>
.collectDetail {
  padding: 20px;
  width: 708px;
  border: 1px solid #ddd;
  .title {
    display: flex;
    justify-content: space-between;
    line-height: 26px;
    .name {
      font-size: 20px;
    }
    .returnList {
      font-size: 12px;
      cursor: pointer;
    }
  }
  .content {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .imgUrl {
      width: 402px;
      height: 402px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .imgDetail {
      width: 225px;
      font-size: 14px;
      line-height: 30px;
      .paipin {
        color: #999;
      }
    }
  }
}
</style>
